import $ from 'jquery';

// 콜렉션 컨텍스트
export const $ctx       = $('#vclipColl');
// 펼쳐보기 버튼
export const $extendBtn = $ctx.find('.extend_comp');
// 펼쳐보기 영역
export const $listWrap  = $ctx.find('#_vclipList');
// 문서 전체 영역 (스크롤 애니메이션에 사용)
export const $document = $('html, body');


/** WEBPACK FOOTER **
 ** ./src/VO2/tot/jqdom-static.js
 **/